import jStat from 'jstat';
import each from 'lodash/each';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  Field,
  change,
  formValueSelector
} from 'redux-form';

import { round4 } from 'utilities/math';

import AlphaSliderComponent from './Component';

class AlphaSliderContainer extends React.Component {
  constructor (props) {
    super(props);

    this.handleChange = (_, value) => {
      const { form, mean, stdev } = this.props;

      const alpha =
        this.props.tailType === 'both'
          ? value / 2
          : value;

      const cutoffs = {
        leftCutoff: jStat.normal.inv(alpha, mean, stdev),
        rightCutoff: jStat.normal.inv(1 - alpha, mean, stdev)
      };

      each(cutoffs, (cutoffValue, cutoffType) =>
        this.props.change(
          form,
          cutoffType,
          round4(cutoffValue)
        )
      );
    };
  }

  render () {
    return (
      <Field
        name="alpha"
        min={0.01} max={0.99}
        onChange={this.handleChange}
        component={AlphaSliderComponent}
      />
    );
  }
}

AlphaSliderContainer.propTypes = {
  change: PropTypes.func.isRequired,
  form: PropTypes.string.isRequired,

  mean: PropTypes.number.isRequired,
  stdev: PropTypes.number.isRequired,

  tailType: PropTypes.string.isRequired
};

const mapStateToProps = (state, props) => {
  const selector = formValueSelector(props.form);
  return { tailType: selector(state, 'tailType') };
};

const mapDispatchToProps = {
  change
};

export default connect(mapStateToProps, mapDispatchToProps)(
  AlphaSliderContainer
);
